import { render, staticRenderFns } from "./RptResearchIncome.vue?vue&type=template&id=73ce7aa9&scoped=true&"
import script from "./RptResearchIncome.vue?vue&type=script&lang=js&"
export * from "./RptResearchIncome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ce7aa9",
  null
  
)

export default component.exports